import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { loggingProviderOptions } from "../../../schema/types/org/utils";
import { CloudWatch } from "./cloudwatch";
import { Coralogix } from "./coralogix";
import { Datadog } from "./datadog";
import { Elastic } from "./elastic";
import { Fluentd } from "./fluentd";
import { Logzio } from "./logzio";
import { OpenTelemetry } from "./opentelemetry";
import { Stackdriver } from "./stackdriver";
import { Syslog } from "./syslog";
import { S3 } from "./s3";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";

interface Props {
  index: number;
}
export const ExternalLogs: React.FC<Props> = React.memo(({ index }) => {
  const provider = useCpFormValue(`logging.${index}.provider`);

  return (
    <>
      <div className="cpln-form-section cpln-ant-tab-content">
        <Card>
          <CardTitle>External Logs Provider</CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`logging.${index}.provider`}>Logging Provider</CpLabel>
              <CpSelect name={`logging.${index}.provider`} options={loggingProviderOptions} style={{ width: 600 }} />
              <CpErrorWarning name={`logging.${index}.provider`} />
            </CpFormItem>
            {provider === "cloudWatch" ? <CloudWatch index={index} /> : null}
            {provider === "coralogix" ? <Coralogix index={index} /> : null}
            {provider === "datadog" ? <Datadog index={index} /> : null}
            {provider === "elastic" ? <Elastic index={index} /> : null}
            {provider === "fluentd" ? <Fluentd index={index} /> : null}
            {provider === "logzio" ? <Logzio index={index} /> : null}
            {provider === "opentelemetry" ? <OpenTelemetry index={index} /> : null}
            {provider === "s3" ? <S3 index={index} /> : null}
            {provider === "stackdriver" ? <Stackdriver index={index} /> : null}
            {provider === "syslog" ? <Syslog index={index} /> : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
});
